// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main{
    width: 100% !important;
    max-width: 100% !important;
}
#app-container,
#app-container button,
#app-container a,
#app-container input,
#app-container select {
    text-transform: none;
    letter-spacing: normal;
    font-family: "Visuelt Pro", Helvetica, Arial, Roboto, sans-serif;
}

#app-container .quickview-external-container .quickadd.show {
    height: 100%;
}

#app-container .quickview-external-container .product-quickadd {
    text-align: left;
}

#app-container .quickview-external-container .quickadd.show .loader {
    min-height: 72px;
    align-items: center;
    justify-content: center;
}

#app-container .quickview-external-container .quickadd.show .loader-indicator {
    max-width: 34px;
    max-height: 34px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;;;;;IAKI,oBAAoB;IACpB,sBAAsB;IACtB,gEAAgE;AACpE;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["#main{\n    width: 100% !important;\n    max-width: 100% !important;\n}\n#app-container,\n#app-container button,\n#app-container a,\n#app-container input,\n#app-container select {\n    text-transform: none;\n    letter-spacing: normal;\n    font-family: \"Visuelt Pro\", Helvetica, Arial, Roboto, sans-serif;\n}\n\n#app-container .quickview-external-container .quickadd.show {\n    height: 100%;\n}\n\n#app-container .quickview-external-container .product-quickadd {\n    text-align: left;\n}\n\n#app-container .quickview-external-container .quickadd.show .loader {\n    min-height: 72px;\n    align-items: center;\n    justify-content: center;\n}\n\n#app-container .quickview-external-container .quickadd.show .loader-indicator {\n    max-width: 34px;\n    max-height: 34px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
